<div *ngIf="!showCollectionTitle && modelName==='assign-page' " class="assign-page-container">
    <div *ngFor="let group of assignPageList; let i = index">
        <div class="assignment-group-name">
            <p bulbEllipsify class="group-text">{{group.displayName}}</p>
        </div>
        <div class="collection-margin">
            <p class="new-collection collection-label">
                <input class="input-cursor" value="" type="radio" (change)="updatePrimary($event, assignPageList[i])" [(ngModel)]="assignmentId" >{{createNewAssignment}}
            </p>
        </div>
        <div class="collection-margin" *ngFor="let collection of assignPageList[i].folders">
            <p bulbEllipsify class="collection-label" >
                <input class="input-cursor" id="{{collection.folderId}}" (change)="updatePrimary($event, assignPageList[i])" [value]='collection.folderId' type="radio" name="enums" [(ngModel)]="assignmentId" >{{collection.folderName}}
            </p>
        </div>
    </div>
</div>


<div *ngIf="showCollectionTitle" class="collection-title-container">
    <aero-input type="text" [id]="'bulbcollectionTitle'" [required]="true" label="{{ 'assignment.collectionTitle' | transloco }}"
      name="collectionTitle" (input)="change($event)" [autofocus]=true [(ngModel)]="collectionTitle" [maxlength]="70">
    </aero-input>
</div>

<div *ngIf="modelName==='non-bulb-plus'" class="non-bulb-plus-container">
    <div *ngFor="let accounts of ineligibleAccounts">
        <p class="account-name">{{accounts.displayName}}</p>
    </div>
</div>
